import { render, staticRenderFns } from "./CustomOptionSelectorObject.vue?vue&type=template&id=1407515c&scoped=true"
import script from "./CustomOptionSelectorObject.vue?vue&type=script&lang=js"
export * from "./CustomOptionSelectorObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1407515c",
  null
  
)

export default component.exports